import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/PromoPageContainer/PromoPageContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { HighlightedTilesSection } from 'components/no-auth/common/sections/HighlightedTilesSection';
import { PaymentSystemLogos } from 'components/no-auth/common/sections/PaymentSystemLogos';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import VideoSectionV2 from 'components/no-auth/common/sections/VideoSectionV2';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const AboutUsPage = (props) => {
    return (
        <PromoPageContainer bgColor={'eggshell02'}>
            {props.heroTitle && <HeroSection title={props.heroTitle} text={props.heroText} bgImg={props.heroBgImg} img={props.heroImg} data={props.heroData} />}
            <ColoredSectionContainer>
                {props.headline1Title && <HeadingSection titleVariant={'h3'} title={props.headline1Title} text={props.headline1Text} />}
                {props.tilesHighlightedSection && <HighlightedTilesSection data={props.tilesHighlightedSection} />}
                {props.headline1BottomText && <HeadingSection text={props.headline1BottomText} noTopIndent />}
            </ColoredSectionContainer>
            <ColoredSectionContainer bgColor={'purple5'} bottomPadding doubleTopPadding>
                {props.headline2Title && <HeadingSection titleVariant={'h3'} title={props.headline2Title} text={props.headline2Text} />}
                {props.tilesSection2 && <TilesSection lang={props.lang} country={props.country} data={props.tilesSection2} loadingLazy />}
            </ColoredSectionContainer>
            {props.videoUrl && (
                <VideoSectionV2
                    videoUrl={props.videoUrl}
                    videoTitle={props.videoTitle}
                    videoPreviewImg={props.videoPreviewImg}
                    btn={props.videoBtn}
                    sectionTitle={props.videoSectionTitle}
                    sectionText={props.videoSectionText}
                    hasTopPadding
                />
            )}
            <ColoredSectionContainer bgColor={'purple5'} bottomPadding>
                {props.headline5Title && <HeadingSection titleVariant={'h3'} title={props.headline5Title} text={props.headline5Text} noBottomIndent />}
            </ColoredSectionContainer>
            <ColoredSectionContainer bgColor={'white'} bottomPadding>
                {props.headline3Title && <HeadingSection titleVariant={'h3'} title={props.headline3Title} text={props.headline3Text} />}
                {props.sendReceiveTiles && <TilesSection lang={props.lang} country={props.country} data={props.sendReceiveTiles} loadingLazy />}
            </ColoredSectionContainer>
            <ColoredSectionContainer>
                {props.headline4Title && <HeadingSection titleVariant={'h3'} title={props.headline4Title} text={props.headline4Text} />}
                {props.cardsIcons && props.topIcon && <PaymentSystemLogos logos={props.cardsIcons} topIcon={props.topIcon} loadingLazy />}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};
const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroImg: state.extra?.strapiApi?.hero_block?.img,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroData: state.extra?.strapiApi?.hero_block,

        videoUrl: state.extra?.strapiApi?.video_section?.url,
        videoTitle: state.extra?.strapiApi?.video_section?.title,
        videoBtn: state.extra?.strapiApi?.video_section?.btn,
        videoPreviewImg: state.extra?.strapiApi?.video_section?.img,
        videoSectionTitle: state.extra?.strapiApi?.video_section?.title,
        videoSectionText: state.extra?.strapiApi?.video_section?.description,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,
        headline1BottomText: state.extra?.strapiApi?.headline1_bottom?.text,

        sendReceiveTiles: state.extra?.strapiApi?.tiles_section,

        tilesHighlightedSection: state.extra?.strapiApi?.tiles_highlighted,

        headline2Title: state.extra?.strapiApi?.headline2?.title,
        headline2Text: state.extra?.strapiApi?.headline2?.text,

        tilesSection2: state.extra?.strapiApi?.tiles_section2,

        headline3Title: state.extra?.strapiApi?.headline3?.title,
        headline3Text: state.extra?.strapiApi?.headline3?.text,

        headline4Title: state.extra?.strapiApi?.headline4?.title,
        headline4Text: state.extra?.strapiApi?.headline4?.text,

        headline5Title: state.extra?.strapiApi?.headline5?.title,
        headline5Text: state.extra?.strapiApi?.headline5?.text,

        cardsIcons: state.extra?.strapiApi?.cards_icons,
        topIcon: state.extra?.strapiApi?.cards_icons2,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(AboutUsPage));
